import { useSakeBrewersTable } from '../hooks/useSakeBrewersTable';
import { CommonDataList } from '../components/CommonDataList';

const SakeBrewersPage = () => {
  const { table, loading, error } = useSakeBrewersTable('src.services.sake_brewers_service');

  return (
    <CommonDataList
      table={table}
      loading={loading}
      error={error}
      title="酒蔵リスト"
    />
  );
};

export default SakeBrewersPage